import { render, staticRenderFns } from "./RenewalPoliciesNotReleased.vue?vue&type=template&id=4c9c3ef9&"
import script from "./RenewalPoliciesNotReleased.vue?vue&type=script&lang=js&"
export * from "./RenewalPoliciesNotReleased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports